export default __webpack_public_path__ + "static/media/Pingoo-giff-3.c7ff0262.mp4";